export enum SaleTypeEnumDnc {
  Retail = 1,
  RetailDirect = 2
}
